import React, { useEffect, useRef, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  Container,
  Button,
  FormGroup,
  TextField,
  InputAdornment,
  IconButton,
  Grid,
  Typography,
} from '@mui/material';
import logoCrevettic2 from '../../images/logo1.1.png';
import logoBludocc2 from '../../images/bludocc-logo2.png';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Tooltip from '@mui/material/Tooltip';
import HelpIcon from '@mui/icons-material/Help';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import ReCAPTCHA from 'react-google-recaptcha';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/lab/Alert';
import CircularProgress from '@mui/material/CircularProgress';
import UserContract from '../../components/userContract/userContract';
import { useDispatch, useSelector } from 'react-redux';
import { setNameProperty } from '../../redux/nameProperty';
import { setNameUser } from '../../redux/nameUser';
import { setAuthentication } from '../../redux/authenticated';
import { useStyles } from '../../components/Styles';
import DialogPropertyOrUserExists from './dialogPropertyOrUserExists';
import DialogForgotPass from '../signin/dialogForgotPass';
import api from '../../services/api';
import crevettic from '../../images/logo1.1.png';
import psf_logo from '../../images/psf_logo.png';
import './style.css';

export const withRouter = (Component) => {
  function Wrapper(props) {
    const history = useHistory();
    return <Component history={history} {...props} />;
  }
  return Wrapper;
};

function IconWithTooltipSenha() {
  return (
    <Tooltip
      title="A senha deve conter ao menos 6 caracters. A senha deve conter ao menos uma letra minúscula, uma letra maíscula e um número."
      placement="right"
      arrow
    >
      <HelpIcon color="primary" fontSize="inherit" />
    </Tooltip>
  );
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

function RegisterPSF(props) {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(
    (state) => state.authenticated.authenticated,
  );

  const [isInvite, setIsInvite] = useState(isAuthenticated);
  const [openDialogRegister, setOpenDialogRegister] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showSend, setShowSend] = useState(true);
  const [open, setOpen] = useState(false);
  const [openError, setOpenError] = useState(false);
  const [contractDialog, setContractDialog] = useState(false);
  const [contractAccepted, setContractAccepted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialogPropertyExists, setOpenDialogPropertyExists] = useState(
    false,
  );
  const [openDialogForgotPass, setOpenDialogForgotPass] = useState(false);
  const [message, setMessage] = useState('');

  const formik = useFormik({
    initialValues: {
      username: '',
      email: '',
      password: '',
      password_confirmation: '',
    },
    validationSchema: Yup.object({
      username: Yup.string().required('Campo Obrigatório'),
      email: Yup.string()
        .email('Digite um email válido')
        .required('Campo Obrigatório'),
      password: Yup.string()
        .matches(
          /^((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]))/,
          'A senha deve conter ao menos uma letra minúscula, uma letra maiúscula e um número',
        )
        .min(6, 'A senha deve conter ao menos 6 caracteres')
        .required('Campo Obrigatório'),
      password_confirmation: Yup.string()
        .oneOf([Yup.ref('password'), null], 'As senhas devem ser iguais!')
        .required('Campo Obrigatório'),
    }),
    onSubmit: (values) => {
      const data = {
        user: [
          {
            email: values.email,
            username: values.username,
            password: values.password,
            permissions: ['psf_user'],
          },
        ],
      };
      request(data);
    },
  });

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const descriptionElementRef = useRef(null);
  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  async function request(data) {
    try {
      setLoading(true);
      await api
        .post('/properties/userAndDomain', { ...data, type: 'psf_user' })
        .then((response) => {
          setOpenDialogRegister(true);
        });
    } catch (err) {
      if (
        err.response.data.statusCode === 400
        && err.response.data.message !== 'Email já cadastrado no sistema'
      ) {
        setMessage(err.response.data.message);
        setOpenDialogPropertyExists(true);
      } else {
        setOpenDialogPropertyExists(true);
      }
    }
    setLoading(false);
  }

  function onChangeRecaptcha(value) {
    setShowSend(false);
  }

  function handleClose(event, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpenError(false);
  }

  function handleLogout() {
    // logout2();
    dispatch(setNameProperty(''));
    dispatch(setNameUser(''));
    dispatch(setAuthentication(false));
    // history.replace("/");
  }

  function changeContractAccepted() {
    setContractAccepted(true);
    setContractDialog(false);
    formik.handleSubmit();
  }

  return (
    <div>
      <Container>
        <form onSubmit={formik.handleSubmit}>
          {contractDialog && (
            <UserContract contractAccepted={changeContractAccepted} />
          )}
          {openDialogPropertyExists && (
            <DialogPropertyOrUserExists
              message={message}
              email={formik.email}
            />
          )}
          <Typography
            style={{ marginTop: 150 }}
            variant="h6"
            align="center"
            gutterBottom
          >
            <img style={{ maxHeight: '120px' }} src={crevettic} />
            <img className="psf-logo" src={psf_logo} />
          </Typography>
          <Typography
            style={{ marginBottom: 25 }}
            variant="h6"
            align="center"
            gutterBottom
          >
            CADASTRAR NOVO PSF
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <div style={{ textAlign: 'center' }}>
                <FormGroup>
                  <TextField
                    id="formGridName"
                    label="Nome de Usuário"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    name="username"
                    placeholder="Nome de usuário"
                    type="text"
                    value={formik.values.username}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.username && formik.errors.username}
                    helperText={
                      formik.touched.username
                      && formik.errors.username
                      && formik.errors.username
                    }
                  />
                </FormGroup>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ textAlign: 'center' }}>
                <FormGroup>
                  <TextField
                    InputLabelProps={{
                      style: { pointerEvents: 'auto' },
                      shrink: true,
                    }}
                    id="formGridResp"
                    label="Email"
                    variant="outlined"
                    name="email"
                    placeholder="Email"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.email && formik.errors.email}
                    helperText={
                      formik.touched.email
                      && formik.errors.email
                      && formik.errors.email
                    }
                  />
                </FormGroup>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ textAlign: 'center' }}>
                <FormGroup>
                  <TextField
                    InputLabelProps={{
                      style: { pointerEvents: 'auto' },
                      shrink: true,
                    }}
                    id="formGridResp"
                    label={(
                      <div>
                        Senha
                        {' '}
                        <IconWithTooltipSenha />
                      </div>
                    )}
                    variant="outlined"
                    name="password"
                    placeholder="Senha"
                    type={showPassword ? 'text' : 'password'}
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={formik.touched.password && formik.errors.password}
                    helperText={
                      formik.touched.password
                      && formik.errors.password
                      && formik.errors.password
                    }
                  />
                </FormGroup>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div style={{ textAlign: 'center' }}>
                <FormGroup>
                  <TextField
                    id="formGridResp"
                    label="Confirmar senha"
                    variant="outlined"
                    InputLabelProps={{ shrink: true }}
                    name="password_confirmation"
                    placeholder="Senha"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={formik.values.password_confirmation}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowConfirmPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {showConfirmPassword ? (
                              <Visibility />
                            ) : (
                              <VisibilityOff />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    error={
                      formik.touched.password_confirmation
                      && formik.errors.password_confirmation
                    }
                    helperText={
                      formik.touched.password_confirmation
                      && formik.errors.password_confirmation
                      && formik.errors.password_confirmation
                    }
                  />
                </FormGroup>
              </div>
            </Grid>
          </Grid>
          <FormGroup />

          <ReCAPTCHA
            className={classes.recaptcha}
            sitekey={
              process.env.REACT_APP_PLATAFORM === 'crevettic'
                ? '6LeOkXYdAAAAAMXuoD12Qm6yUzZyZwIRewCy_zCT'
                : '6LcvnXYdAAAAAFd-l9KbUs3YmADoBJs-iBBe_xjZ'
            }
            onChange={onChangeRecaptcha}
          />

          <Dialog
            open={openDialogRegister}
            onClose={() => {}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {`Precisamos que você confirme o seu cadastro, enviamos um e-mail para ${
                formik.values.email}`}
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => history.push('/signin')} color="secondary">
                Ir para a tela de login
              </Button>
            </DialogActions>
          </Dialog>

          <Dialog
            open={isInvite}
            onClose={() => {}}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              Para cadastar um novo usuário é preciso deslogar o usuário conectado
            </DialogTitle>
            <DialogActions>
              <Button onClick={() => history.push('/home')} color="secondary">
                Continuar
              </Button>
              <Button onClick={handleLogout} color="primary">
                Deslogar
              </Button>
            </DialogActions>
          </Dialog>

          <FormGroup>
            <Button
              disabled={showSend}
              className={classes.buttonRegister}
              variant="contained"
              onClick={() => setContractDialog(true)}
              size="large"
            >
              {loading ? <CircularProgress /> : 'Cadastrar'}
            </Button>
          </FormGroup>

          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={open}
            autoHideDuration={6000}
          >
            <Alert severity="success">Ação Submetida com Sucesso!</Alert>
          </Snackbar>
          <Snackbar
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            open={openError}
            onClose={handleClose}
            autoHideDuration={3000}
          >
            <Alert severity="error">
              Erro ao submeter ação! Tente novamente.
            </Alert>
          </Snackbar>
        </form>
        <hr />
        <Typography
          style={{ marginToP: 25, marginBottom: 25 }}
          variant="subtitle1"
          align="center"
          gutterBottom
        >
          <Link
            style={{ textDecoration: 'none', color: '#1572C6' }}
            to="/signin"
          >
            {' '}
            Fazer Login
            {' '}
          </Link>
        </Typography>
        <Typography variant="body2" align="center">
          Caso não lembre sua senha clique em
          {' '}
          <span
            onClick={() => setOpenDialogForgotPass(true)}
            style={{ color: '#1572C6', cursor: 'pointer' }}
          >
            redefinir minha senha!
          </span>
        </Typography>
        {openDialogForgotPass && (
          <DialogForgotPass close={() => setOpenDialogForgotPass(false)} />
        )}
      </Container>
    </div>
  );
}

export default withRouter(RegisterPSF);
